import React, { useState } from "react";
import { CgProfile } from "react-icons/cg";
import { FaAngleRight } from "react-icons/fa6";
import { FiGift } from "react-icons/fi";
import { GoListOrdered } from "react-icons/go";
import { IoWalletSharp } from "react-icons/io5";
import { Link, useNavigate } from "react-router-dom";
import Cookies from "js-cookie"; // Import js-cookie library
import CustomeSignInPopup from "../User/Signup/CustomeSignInPopup";
import { useDispatch, useSelector } from "react-redux";
import { getAuth, signOut } from "firebase/auth";
import { clearDiscount } from "../../redux/promoSlice";
import { clearCart } from "../../redux/action/cart";

const Dashboard = () => {
  const { isAuthenticated, user, loading } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  // State to manage whether to show the sign-in popup
  const [showSignInPopup, setShowSignInPopup] = useState(false);
  const navigate = useNavigate();
  const handleLogout = () => {
    // Remove the token from cookies
    dispatch(clearDiscount());
    dispatch(clearCart());
    localStorage.setItem('cart', JSON.stringify([]));
    Cookies.remove("accessToken");
    localStorage.removeItem("userId"); 
    const auth = getAuth();
    signOut(auth)
      .then(() => {
        // Sign-out successful.
        console.log("User has been logged out.");
      })
      .catch((error) => {
        console.log("Error during logout:", error.message);
      });

    // Navigate to the homepage or login page
    navigate("/");

    // Reload the page to reset the state
    window.location.reload();

    // Show the sign-in popup after logout
    setShowSignInPopup(true);
  };

  return (
    <div className="">
      <div className="px-16 py-6 w-full text-6xl heading font-bold tracking-wide text-center text-white whitespace-nowrap bg-[#AF313D] max-md:px-5 max-md:max-w-full max-md:text-4xl">
        {user?.name}
      </div>
      <div className="w-[80%] mx-auto mt-8 px-8 flex flex-col gap-16">
        <div className="cursor-pointer">
          <Link to="/profile">
            <div className="flex justify-between items-center">
              <div className="flex items-center gap-3">
                <CgProfile color="#AD343E" className="md:text-[2rem]" />
                <h1 className="body font-bold lg:text-[40px] text-[19.56px] body sm:text-[19.56px] md:text-[32.48px]">
                  Profile
                </h1>
              </div>
              <FaAngleRight className="md:text-[2rem]" />
            </div>
            <div className="lg:w-full h-[1px] bg-[#000000]"></div>
          </Link>
        </div>

        <div className="cursor-pointer">
          <Link to="/your-orders">
            <div className="flex justify-between items-center">
              <div className="flex items-center gap-3">
                <GoListOrdered color="#AD343E" className="md:text-[2rem]" />
                <h1 className="body font-bold lg:text-[40px] text-[19.56px] sm:text-[19.56px] md:text-[32.48px]">
                  Orders
                </h1>
              </div>
              <FaAngleRight className="md:text-[2rem]" />
            </div>
            <div className="lg:w-full h-[1px] bg-[#000000]"></div>
          </Link>
        </div>

        <div className="cursor-pointer">
          <Link to="/loyalty-program">
            <div className="flex justify-between items-center">
              <div className="flex items-center gap-3">
                <FiGift color="#AD343E" className="md:text-[2rem]" />
                <h1 className="body font-bold lg:text-[40px] text-[19.56px] sm:text-[19.56px] md:text-[32.48px]">
                  Loyalty Programs
                </h1>
              </div>
              <FaAngleRight className="md:text-[2rem]" />
            </div>
            <div className="lg:w-full h-[1px] bg-[#000000]"></div>
          </Link>
        </div>

        <div className="cursor-pointer">
          <Link to="/wallet">
            <div className="flex justify-between items-center">
              <div className="flex items-center gap-3">
                <IoWalletSharp color="#AD343E" className="md:text-[2rem]" />
                <h1 className="body font-bold lg:text-[40px] text-[19.56px] sm:text-[19.56px] md:text-[32.48px]">
                  Wallet
                </h1>
              </div>
              <FaAngleRight className="md:text-[2rem]" />
            </div>
            <div className="lg:w-full h-[1px] bg-[#000000]"></div>
          </Link>
        </div>
      </div>

      <div className="flex items-center justify-center mt-20 mb-40">
        <button
          onClick={handleLogout}
          className="md:text-[47.48px] sm:text-[19.56px] text-[19.56px] body font-medium bg-[#AF313D] text-white border-[2.37px] md:h-[105.24px] md:w-[70%] lg:w-[75%] h-[43.37px] sm:h-[43.37px] w-[65%] sm:w-[65%] border-[##000000] rounded-md shadow-md"
        >
          Log out
        </button>
      </div>

      {/* Conditionally render the sign-in popup */}
      {showSignInPopup && <CustomeSignInPopup />}
    </div>
  );
};

export default Dashboard;
